import { render, staticRenderFns } from "./AxaptaUserHolidayList.vue?vue&type=template&id=38562cd4"
import script from "./AxaptaUserHolidayList.js?vue&type=script&lang=js&external"
export * from "./AxaptaUserHolidayList.js?vue&type=script&lang=js&external"
import style0 from "./AxaptaUserHolidayList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports